import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/sobre/SobreClient.tsx");
